module.exports = __webpack_public_path__ + "static/media/remove_prod.5f45365d.svg";